import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Popconfirm, Table, Tag, Tooltip } from 'antd';

import { Button } from '../../../../components/index';
import { CargoSuppressionItemType } from '../../../../services/cargoSuppressionApi';

type CargoSuppressionsTableProps = {
  data: CargoSuppressionItemType[];
  loading?: boolean;
  onEdit: (item: CargoSuppressionItemType) => void;
  onDelete: (item: CargoSuppressionItemType) => void;
};

export function CargoSuppressionsTable(props: CargoSuppressionsTableProps) {
  const { data, loading, onEdit, onDelete } = props;

  const columns = [
    {
      title: 'Tipo',
      dataIndex: 'ncmsh2',
      key: 'tipo',
      width: 110,
      render: (ncmsh2: string) =>
        ncmsh2 === 'CT' ? (
          <Tag color="blue">Contêiner</Tag>
        ) : (
          <Tag color="green">Demais Cargas</Tag>
        ),
    },
    {
      title: 'NCMSH2 / NCMSH4 / Contêiner',
      key: 'identifier',
      render: (_: unknown, item: CargoSuppressionItemType) => {
        if (item.ncmsh2 === 'CT') {
          const cheio = item.full_or_empty === 'C' ? ' (Cheio)' : ' (Vazio)';
          return `${item.id_conteiner || '-'}${cheio}`;
        }
        return `${item.ncmsh2}${item.ncmsh4 ? ` / ${item.ncmsh4}` : ''}`;
      },
    },
    {
      title: 'Peso (ton)',
      dataIndex: 'weight',
      key: 'weight',
      width: 110,
      render: (weight: string | null) => weight ?? '-',
    },
    {
      title: 'Motivo',
      dataIndex: 'reason',
      key: 'reason',
      ellipsis: { showTitle: false },
      render: (reason: string) => (
        <Tooltip placement="topLeft" title={reason}>
          {reason}
        </Tooltip>
      ),
    },
    {
      title: 'Ações',
      key: 'actions',
      width: 110,
      render: (_: unknown, item: CargoSuppressionItemType) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit(item)}
          />
          <Popconfirm
            title="Remover esta supressão?"
            okText="Sim"
            cancelText="Não"
            onConfirm={() => onDelete(item)}
          >
            <Button type="link" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <Table
      rowKey="id"
      size="small"
      pagination={false}
      loading={loading}
      dataSource={data}
      columns={columns as any}
      locale={{ emptyText: 'Nenhuma supressão registrada' }}
    />
  );
}
